import { render, staticRenderFns } from "./AverageRating.two.vue?vue&type=template&id=1e58660c"
import script from "./AverageRating.two.vue?vue&type=script&lang=js"
export * from "./AverageRating.two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports